import React from 'react'

import { Box, Button, Color, Display, FlexDirection } from '@gousto-internal/citrus-react'

import { SimpleAddButton } from './SimpleAddButton/SimpleAddButton'
import { StepperAddButton } from './StepperAddButton/StepperAddButton'

type AddRecipeButtonProps = {
  canAddRecipes: boolean
  isNegativeSurcharge?: boolean
  isOutOfStock: boolean
  onClickAdd: (isFirstInBatchOfSameRecipes: boolean) => void
  onClickRemove: () => void
  quantity: number
  reachedLimit: boolean
  surchargeLabel: string | null
}

export const AddRecipeButton = ({
  isNegativeSurcharge,
  isOutOfStock,
  onClickAdd,
  onClickRemove,
  quantity,
  reachedLimit,
  surchargeLabel,
}: AddRecipeButtonProps) => {
  const disabled = isOutOfStock || reachedLimit
  const dataTesting = quantity < 1 ? 'menuRecipeAdd' : 'menuAddServings'

  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Row} width={'100%'}>
      {isOutOfStock ? (
        <Button aria-label="Sold out recipe" disabled width="100%">
          Sold out
        </Button>
      ) : (
        <Box
          data-testing={disabled ? 'menuRecipeAddDisabled' : dataTesting}
          width="full"
          style={{ flex: 1, backgroundColor: Color.White }}
        >
          {quantity > 0 ? (
            <StepperAddButton
              isNegativeSurcharge={isNegativeSurcharge}
              isOutOfStock={isOutOfStock}
              onClickAdd={onClickAdd}
              onClickRemove={onClickRemove}
              quantity={quantity}
              reachedLimit={reachedLimit}
              surchargeLabel={surchargeLabel}
            />
          ) : (
            <SimpleAddButton
              disabled={disabled}
              isNegativeSurcharge={isNegativeSurcharge}
              onClick={onClickAdd}
              surchargeLabel={surchargeLabel}
            />
          )}
        </Box>
      )}
    </Box>
  )
}
